import * as React from 'react';
import { graphql } from 'gatsby';

import Seo from '../components/seo';

import Support from '../components/pages/support';

const SupportPage = ({ data, location }) => {
  const pageTitle = 'Support';

  return (
    <div>
      <Seo title={pageTitle} />
      <Support />
    </div>
  );
};

export default SupportPage;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }`;
